<script>
    export let Num, Title
</script>

<div class="top">
    <svg xmlns="http://www.w3.org/2000/svg" width="150" height="56" viewBox="0 0 150 56" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M76.7271 15.3062L76.7795 15.3559H15.356L15.356 55.1094L7.62939e-05 38.9453V15.3559H0V0H60.6154L72.1943 11H145.294L150 15.3062H76.7271Z" fill="#7A67FF"/>
      </svg>

    <div class="title">[{Num}] {Title}</div>
</div>

<style lang="scss">
    .top {
        width: calc(100% - 30px);
        margin-bottom: 24px;
        height: fit-content;
        padding-top: 25px;
        padding-left: 30px;
        position: relative;

        .title {
            width: fit-content;
            color: $cl2;
            font-family: aggro;
            
            @include mobile { font-size: 20px; }
            @include tablet { font-size: 30px; }
            @include desktop { font-size: 30px; }
            @include wide { font-size: 30px; }
        }

        svg {
            position: absolute;
            top: 0;
            left: 0;
        }
    }
</style>